export default {
  URL: '/api',
  METADATA: '/all-metadata',
  LOGIN: '/users/login',
  CONFIRM: '/users/confirm',
  RESET: '/users/reset',
  SIGN_UP: '/users',
  USER: '/user',
  USERS: '/users',
  ARTICLE: '/article',
  ARTICLES: '/articles',
  BLOCKS: '/blocks',
  FILES: '/files',
  OPPORTUNITIES: '/opportunities',
  OPPORTUNITY_TYPES: '/opportunity-types',
  PROFILES: '/profiles',
  COMPANIES: '/companies',
  CONTACTS: '/contacts',
  BLOG: '/blog',
  BLOG_ARTICLE: '/blog/articles',
  BLOG_CATEGORY: '/blog/categories',
  DOMAIN: '/domains',
  COURSE_LEVEL: '/course-levels',
  SKILL: '/skills',
  SKILL_LEVEL: '/skill-levels',
  ABOUT: '/pages/about',
  ELIFY: '/elify',
  META: '/meta',
  TEXTKERNEL: '/textkernel',
  CONFIGURATIONS: '/configurations',
  COMMUNITIES: '/communities',
  LEARN: '/learn',
  LEARN_SOURCE: '/learn/learn-source',
  LEARN_SOURCE_GROUP: '/learn/learn-source-group',
  LEARN_CONTENT_TYPE: '/learn/learn-content-type'
}
